import { BaseModel } from "model/BaseModel";
import NivelAprovacaoUsuario from "./NivelAprovacaoUsuario";

export default class NivelAprovacao implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    tipoRotina: string;
    observacao: string;
    ativo: boolean;
    nivelAprovacaoUsuarios: NivelAprovacaoUsuario[];

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        tipoRotina = 'VIAGEM',
        observacao = '',
        ativo = true,
        nivelAprovacaoUsuarios: NivelAprovacaoUsuario[] = [],
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.tipoRotina = tipoRotina;
        this.observacao = observacao;
        this.ativo = ativo;
        this.nivelAprovacaoUsuarios = nivelAprovacaoUsuarios;
    }
}
